<template>
  <membership-detail :is-edit="true"></membership-detail>
</template>
<script>
import MembershipDetail from './MembershipDetail';

export default {
  name: 'UpdateMembership',
  components: { MembershipDetail },
};
</script>
